import { axios } from '@/utils/request'

const api = {
  master: '/master/masterContract',
}

export function queryMasterContract (parameter) {//查看师傅合同列表
  return axios({
    url: api.master + '/queryMasterContract',
    method: 'get',
    params: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function addMasterContract (parameter) {//新增师傅合同
  return axios({
    url: api.master + '/addMasterContract',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function editMasterContract (parameter) {//修改师傅合同
  return axios({
    url: api.master + '/editMasterContract',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function deleteMasterContract (parameter) {//删除师傅合同
  return axios({
    url: api.master + '/deleteMasterContract',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function disableMasterContract (parameter) {//禁用师傅合同
  return axios({
    url: api.master + '/disableMasterContract',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}


export function enableMasterContract (parameter) {//启用师傅合同
  return axios({
    url: api.master + '/enableMasterContract',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function GET(parameter) {//设置师傅合同
  return axios({
    url: api.master + `/get/${parameter}`,
    method: 'get',
  })
}
export function toMainMasterContract (parameter) {//设置师傅合同
  return axios({
    url: api.master + '/toMainMasterContract',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
export const accessoryExport = api.accessory + '/export'